angular.module('gym.components').directive('reportFilterValueInput', function() {
  return {
    restrict: 'AE',
    template: require('templates/components/reports/report_filter_value_input.html.slim'),
    scope: {
      newFilter: '=',
      filterType: '=',
      dropdownOptions: '=',
      disableFromNow: '=',
      condition: '=',
      periods: '=',
      multipliers: '='
    },
    controller: ["$rootScope", "$scope", function($rootScope, $scope) {
      $scope.users = $rootScope.gym.users;
      $scope.locations = $rootScope.gym.locations;
      $scope.displayTextInput = function() {
        var ref, ref1, ref2;
        return ((ref = $scope.filterType) === 'location' || ref === 'user' || ref === 'dropdown') && ((ref1 = (ref2 = $scope.condition) != null ? ref2[0] : void 0) === 'Contains' || ref1 === 'Does not contain');
      };
      return $scope.getFilterType = function() {
        if ($scope.filterType === 'month' && $scope.newFilter.relative_date) {
          return 'relative_month';
        } else {
          return $scope.filterType;
        }
      };
    }]
  };
});
